// Open Overlays
$(document).ready(function(){
  	
	$('.overlayBTN').click(function(){
		var overlay = $(this).data('overlay');
    openProductOverlay(overlay);
	});
	
	$('.closeButton, .overlayBG').click(function(e){
    if(e.target !== e.currentTarget) return;
		closeProductOverlay(e);
	});  	
		 
});  

function openProductOverlay(overlay){
  console.log('openProductOverlay', overlay);
  $('body').addClass('openOverlay');      
  $('#'+overlay).fadeIn();
}

function closeProductOverlay(e){
  console.log('closeProductOverlay', e);
  $('body').removeClass('openOverlay');
  $('.overlayBG').fadeOut();
}


// Quantity values
$(document).on('click','.up',function(e){   
  console.log('up');
  e.preventDefault();
  fieldName = $(this).attr('field');
  var currentVal = parseInt($('input[name='+fieldName+']').val());
  if (!isNaN(currentVal)) {
    $('input[name='+fieldName+']').val(currentVal + 1);
  } else {
    $('input[name='+fieldName+']').val(1);
  }
});
  
$(document).on('click','.down',function(e){ 
  console.log('down');  
  e.preventDefault();
  fieldName = $(this).attr('field');
  var currentVal = parseInt($('input[name='+fieldName+']').val());
  if (!isNaN(currentVal) && currentVal > 1) {
    $('input[name='+fieldName+']').val(currentVal - 1);
  } else {
    $('input[name='+fieldName+']').val(1);
  }
}); 

Fancybox.bind('[data-fancybox="gallery"]', {
  Toolbar: {
    display: [
      "counter",
      "close",
    ],
  },
});